import BlueprintUploadIllustration from '@box/blueprint-web-assets/illustrations/Medium/UploadCloud';
import React from 'react';
import BuieUploadIllustration from '../../../../assets/icons/upload-illustration';
import { useShouldRenderBlueprint } from '../../../useShouldRenderBlueprint';
import VariantComponent from '../../../variant-component';

const OldIllustration = () => {
  return <BuieUploadIllustration />;
};

const NewIllustration = () => {
  return (
    <BlueprintUploadIllustration
      data-testid="blueprint-upload-illustration"
      height={140}
      width={140}
    />
  );
};

const UploadIllustration = () => {
  // Should be addressed in FORMS-21209
  const shouldRenderBlueprint = useShouldRenderBlueprint();
  return (
    <VariantComponent
      NewComponent={NewIllustration}
      OldComponent={OldIllustration}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
};

export default UploadIllustration;
